import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;

export const submitEnquiry = (data) => {
  if (!BASE) return Promise.reject(new Error("Form service unavailable"));
  return axios.post(`${BASE}/api/enquiries`, data);
};

export const WINGS = {
  pitsus: { name: "PITSUS", domain: "pitsus.com", email: "info@pitsus.com", phone: "+1 (510) 509 7702", tel: "+15105097702", tz: "America/Los_Angeles" },
  pitsind: { name: "PITSIND", domain: "pitsind.com", email: "info@pitsind.com", phone: "+91 96989 97990", tel: "+919698997990", tz: "Asia/Kolkata" },
};

export const REGIONS = [
  { id: "us", label: "USA", wing: "pitsus" },
  { id: "uk", label: "UK", wing: "pitsind" },
  { id: "eu", label: "EMEA", wing: "pitsind" },
  { id: "apac", label: "APAC", wing: "pitsind" },
];

export const US_ADDRESS = ["#38484 Garway Dr", "Fremont, CA 94536"];
export const INDIA_ADDRESS = ["#116/1, Sir Thiyagaraya Road", "6th Floor, Kasi Arcade, T Nagar", "Chennai 600017"];

export const NAV_LINKS = [
  { to: "/clients", label: "hire talent", testid: "nav-clients-link" },
  { to: "/talent", label: "find work", testid: "nav-talent-link" },
  { to: "/how-we-work", label: "how we work", testid: "nav-how-link" },
  { to: "/about", label: "about", testid: "nav-about-link" },
  { to: "/contact", label: "contact", testid: "nav-contact-link" },
];

export const POSITIONS = [
  { name: "cloud & devops", note: "People who keep the lights on at 3 a.m. and automate it so nobody has to next time.", tags: ["AWS", "Azure", "GCP", "Kubernetes", "Terraform", "SRE"], group: "run" },
  { name: "data, ai & ml", note: "Engineers who can tell a model that works in a notebook from one that works on a Tuesday in production.", tags: ["Data Eng", "ML Ops", "GenAI", "Databricks", "Snowflake"], group: "build" },
  { name: "full-stack & mobile", note: "Builders who read the ticket, question it, then ship something better.", tags: ["React", "Node", "Java", ".NET", "Python", "iOS", "Android"], group: "build" },
  { name: "cybersecurity", note: "The quiet ones who think like the attacker so you never have to meet one.", tags: ["SOC", "IAM", "AppSec", "GRC", "Cloud Sec"], group: "protect" },
  { name: "sap", note: "S/4HANA hands who have sat through a cutover weekend and know exactly which transport breaks first.", tags: ["S/4HANA", "SAP FICO", "SAP MM / SD", "SAP ABAP", "SAP BTP", "SuccessFactors"], group: "run" },
  { name: "erp & crm", note: "Consultants who have survived real go-lives and still smile about it.", tags: ["Oracle", "Salesforce", "Workday", "ServiceNow", "Dynamics 365"], group: "run" },
  { name: "quality & automation", note: "Testers who break things on purpose, early, cheaply.", tags: ["Selenium", "Playwright", "Performance", "SDET"], group: "protect" },
  { name: "product & delivery", note: "Leads who turn a messy roadmap into a Monday plan the team actually believes.", tags: ["Product", "Scrum", "Program", "Architecture"], group: "decide" },
];
